// extracted by mini-css-extract-plugin
export default {"container":"Video_container__lccve","image":"Video_image__m-O4M"};